import { FC, useCallback, useEffect, useRef, useState } from 'react';
import FormFieldWrapper from '@shared/form/FormFieldWrapper';

interface ITextInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  width?: string;
  state: any;
  type?: 'text' | 'number';
}

const TextForm: FC<ITextInputProps> = ({
  value,
  onChange,
  state,
  width = null,
  placeholder = '',
  type = 'text',
}) => {
  const [inputFocus, setInputFocus] = useState(false);
  const textInput = useRef<HTMLInputElement>(null);

  const onBlur = useCallback(() => {
    if (value && value.length) return;
    setInputFocus(false);
  }, [value]);

  useEffect(() => {
    if (!value) {
      setInputFocus(false);
    }
  }, [value]);

  const onClick = () => {
    setInputFocus(true);
    textInput?.current?.click();
    textInput?.current?.focus();
  };

  const handleChange = (inputValue: string) => {
    if (type === 'number') {
      //Заменяем запятую на точку для корректной работы
      const normalizedValue = inputValue.replace(',', '.');

      onChange(normalizedValue);
    } else {
      onChange(inputValue);
    }
  };

  return (
    <FormFieldWrapper state={state}>
      <div
        className={`h-[33px] w-full rounded-[8px] bg-[#1B1A1D] px-[10px] flex items-center border border-solid border-[#2B292F]`}
      >
        <input
          onBlur={() => onBlur()}
          autoFocus={false}
          ref={textInput}
          value={value}
          className={`bg-[#1B1A1D] text-[white] outline-none ${inputFocus || value ? 'w-full h-full' : 'w-[0px] h-[0px]'}`}
          onChange={({ target: { value } }) => handleChange(value)}
        />

        <div
          onClick={() => onClick()}
          className={`bg-[#1B1A1D] text-[#777777] ${!inputFocus && !value ? 'w-full h-full flex items-center' : 'hidden'}`}
        >
          {placeholder}
        </div>
      </div>
    </FormFieldWrapper>
  );
};

export default TextForm;
